import axios from 'axios';
import {PaymentStatus} from '@/types/enums';

const SETTLED_STATUSES: PaymentStatus[] = [
    PaymentStatus.COMPLETED,
    PaymentStatus.FAILED,
    PaymentStatus.CANCELLED,
    PaymentStatus.REFUNDED,
];

const IN_FLIGHT_STATUSES: PaymentStatus[] = [PaymentStatus.PENDING, PaymentStatus.UNKNOWN];

const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 30000;

export const isSettled = (status: PaymentStatus) => SETTLED_STATUSES.includes(status);

export const isInFlight = (status: PaymentStatus) => IN_FLIGHT_STATUSES.includes(status);

const sleep = (ms: number, signal?: AbortSignal) =>
    new Promise<void>(resolve => {
        const timer = window.setTimeout(resolve, ms);
        signal?.addEventListener('abort', () => {
            window.clearTimeout(timer);
            resolve();
        }, {once: true});
    });

export async function fetchPaymentStatus(sessionId: string): Promise<PaymentStatus> {
    const {data} = await axios.get(route('payment.status', {session_id: sessionId}));
    return data.status as PaymentStatus;
}

export async function waitForPaymentSettlement(
    sessionId: string,
    {signal}: {signal?: AbortSignal} = {}
): Promise<PaymentStatus> {
    const deadline = Date.now() + POLL_TIMEOUT_MS;
    let status = PaymentStatus.PENDING;

    while (!signal?.aborted) {
        try {
            status = await fetchPaymentStatus(sessionId);

            if (!isInFlight(status)) {
                return status;
            }
        } catch {}

        if (Date.now() >= deadline) {
            break;
        }

        await sleep(POLL_INTERVAL_MS, signal);
    }

    return status;
}
